import React, { useState } from 'react';
import '../App.css';

// Smart API URL switching
const API_BASE_URL =
    window.location.hostname === "staging187611.digassistant.xyz"
        ? "https://api.digassistant.xyz"
        : window.location.hostname === "digassistant.xyz" || window.location.hostname === "www.digassistant.xyz"
        ? "https://api.digassistant.xyz"
        : "http://localhost:8080";

const PaymentFailedOverlay = ({ onClose }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [isProcessing, setIsProcessing] = useState(false);

    const handleClose = () => {
        setIsVisible(false);
        // Store in localStorage so it doesn't show again until payment is fixed
        localStorage.setItem('paymentFailedShown', 'true');
        if (onClose) {
            onClose();
        }
    };

    const handleUpdatePaymentMethod = async () => {
        setIsProcessing(true);
        try {
            const response = await fetch(`${API_BASE_URL}/billing/customer/portal?plan_type=update_payment_method`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText || 'Failed to create portal session');
            }

            const data = await response.json();

            // Redirect to Stripe Customer Portal
            window.location.href = data.url;
        } catch (error) {
            console.error('Error opening customer portal:', error);
            alert('Failed to open payment method update. Please try again.');
            setIsProcessing(false);
        }
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            zIndex: 1000,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <div style={{
                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                border: '2px solid #009e4a',
                borderRadius: '14px',
                padding: '30px',
                maxWidth: '500px',
                textAlign: 'center',
                fontFamily: 'CustomFont',
                color: '#009e4a',
                position: 'relative'
            }}>
                <button 
                    onClick={handleClose}
                    style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        background: 'none',
                        border: 'none',
                        color: '#009e4a',
                        fontSize: '24px',
                        cursor: 'pointer',
                        fontFamily: 'CustomFont',
                        padding: '0',
                        width: '30px',
                        height: '30px',
                        lineHeight: '30px'
                    }}
                    onMouseOver={(e) => {
                        e.target.style.color = '#fcd117';
                    }}
                    onMouseOut={(e) => {
                        e.target.style.color = '#009e4a';
                    }}
                >
                    ×
                </button>
                <h2 style={{ marginBottom: '20px', color: '#fcd117' }}>
                    Payment Failed
                </h2>
                <p style={{ marginBottom: '30px', lineHeight: '1.5' }}>
                    Your payment method failed. Please update your payment method to continue your membership.
                </p>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <button
                        onClick={handleUpdatePaymentMethod}
                        disabled={isProcessing}
                        style={{
                            background: 'none',
                            border: '1px solid #009e4a',
                            color: '#009e4a',
                            padding: '12px 24px',
                            borderRadius: '5px',
                            cursor: isProcessing ? 'not-allowed' : 'pointer',
                            fontFamily: 'CustomFont',
                            fontSize: '16px',
                            transition: 'all 0.2s',
                            opacity: isProcessing ? 0.6 : 1
                        }}
                        onMouseOver={(e) => {
                            if (!isProcessing) {
                                e.target.style.background = '#009e4a';
                                e.target.style.color = 'black';
                            }
                        }}
                        onMouseOut={(e) => {
                            if (!isProcessing) {
                                e.target.style.background = 'none';
                                e.target.style.color = '#009e4a';
                            }
                        }}
                    >
                        {isProcessing ? 'Loading...' : 'Update Payment Method'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentFailedOverlay;
